import { Box, Typography } from "@mui/material";
import { useSubscribeState } from "src/store/features/subscribe.slice";

/**
 * Component replaces the Left "Thank you!" text on the AfterSignUp page.
 * It's only visible on mobile.
 * @returns {JSX.Element} The JSX code for the component
 */
export const SuccessMobileHeader = () => {
  const { subscribeEmail } = useSubscribeState();

  return (
    <Box display={{ sx: "flex", md: "none" }} flexDirection="column" alignItems="start">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap={2}
        px={0}
        width="100%">
        <Typography variant="h6" color="white" align="center" sx={{ mt: -1 }}>
          Thank you!
        </Typography>
        <Typography variant="body1" color="white" align="center">
          {` A verification link has been sent to your email, ${subscribeEmail}`}
          <br />
          {`Please check your inbox and follow the steps to complete your Portal registration.`}
          <br />
          {`(Please check your spam folder if you can't find it)`}
        </Typography>
      </Box>
    </Box>
  );
};
